import React, { Component } from "react";
import CycleFilterContextProvider from "./context/CycleFilterContext";
import CycleFilter from "./CycleFilterv2";
import OverviewContextProvider from "./context/OverviewContext";
import PVAOverviewContextProvider from "./context/PVAOverviewContext";
import PVAView from "./PVAViewv2";
import OverviewView from "./OverviewViewv2";
import CapabilityContextProvider from "./context/CapabilityContext";
import PageHeader from "../PageHeader";
import { FEATURES, PAGE_HEADERS, SHIFT_PLANNING } from "../util/Constants";
import {
  getSettingsInsights,
  getOpsClockEventsAndBreaks,
  getDynamicShiftPlans,
  getDynamicShiftPlanDiff,
} from "./network/OverviewNetworkAPI";
import {
  getFeatureStatus,
  getOverviewQualityMetricsFlag,
} from "../handler/ParentDataHandler";
import { arePlansSame, getDispatchDate, isPlanActedUpon } from "./utils/utils";
import DynamicShiftPlanNotification from "../dynamicShiftPlanning/DynamicShiftPlanNotification";
import QualityMetricsContainer from "../quality/QualityMetricsContainer";
import { QualityProvider } from "../quality/common/QualityContext";
import {
  getCurrentTime,
  getStartTime,
  getStationCode,
} from "../network/NetworkUtil";

class Overviewv2 extends Component {
  dispatchDate = new Date().toISOString().substring(0, 10);
  dynamicShiftPlanEnabled = false;

  state = {
    breaksDataSources: {
      settingsInsights: {},
      opsClockData: {},
      isLMOCSEnabledForOpsClockData: false,
    },
    dynamicShiftPlanNotification: {
      diff: {},
    },
    showQualityMetrics: false,
  };

  componentDidMount() {
    this.fetchSettingsInsights();
    this.isDynamicShiftPlanEnabled();
    this.interval = setInterval(
      () => this.fetchDynamicShiftPlanDiff(),
      SHIFT_PLANNING.DYNAMIC_PLAN_NOTIFICATION_REFRESH,
    );
    // Fetch the overviewQualityMetrics feature flag
    getOverviewQualityMetricsFlag().then((flag) => {
      // Only set to true if flag is boolean true or string "true"
      if (
        flag &&
        (flag.showQualityMetrics === true || flag.showQualityMetrics === "true")
      ) {
        this.setState({ showQualityMetrics: true });
      }
    });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <CapabilityContextProvider>
        <DynamicShiftPlanNotification
          notification={this.state.dynamicShiftPlanNotification}
        />

        <PageHeader {...PAGE_HEADERS.SORT} />
        <CycleFilterContextProvider>
          <CycleFilter />
          <PVAOverviewContextProvider>
            <OverviewContextProvider>
              <OverviewView breaksDataSources={this.state.breaksDataSources} />
            </OverviewContextProvider>

            {this.state.showQualityMetrics && (
              <QualityProvider
                stationCode={getStationCode()}
                startDate={Math.floor(getStartTime() / 1000)}
                endDate={Math.floor(getCurrentTime() / 1000)}
              >
                <QualityMetricsContainer />
              </QualityProvider>
            )}
            <PVAView
              pva={{ processName: "inbound" }}
              breaksDataSources={this.state.breaksDataSources}
            />
          </PVAOverviewContextProvider>
        </CycleFilterContextProvider>
      </CapabilityContextProvider>
    );
  }

  fetchSettingsInsights = () => {
    getSettingsInsights()
      .then((settingsInsights) => {
        this.setState({
          breaksDataSources: {
            ...this.state.breaksDataSources,
            settingsInsights,
          },
        });
        this.dispatchDate = getDispatchDate(settingsInsights);
      })
      .catch(() => false)
      .finally(() => {
        this.fetchIsLMOCSEnabledForOpsClockDataFeatureFlag();
      });
  };

  fetchIsLMOCSEnabledForOpsClockDataFeatureFlag = () => {
    getFeatureStatus([FEATURES.IS_LMOCS_ENABLED_FOR_OPS_CLOCK_DATA]).then(
      (res) => {
        if (res.data && res.data.isLMOCSEnabledForOpsClockData) {
          this.setState({
            breaksDataSources: {
              ...this.state.breaksDataSources,
              isLMOCSEnabledForOpsClockData: true,
            },
          });
          this.fetchOpsClockEventsAndBreaks();
        }
      },
    );
  };

  fetchOpsClockEventsAndBreaks = () => {
    getOpsClockEventsAndBreaks(this.dispatchDate)
      .then((opsClockData) => {
        this.setState({
          breaksDataSources: {
            ...this.state.breaksDataSources,
            opsClockData,
          },
        });
      })
      .catch(() => false);
  };

  isDynamicShiftPlanEnabled = () => {
    getFeatureStatus([FEATURES.IS_DYNAMIC_SHIFT_PLAN_ALERT_ENABLED]).then(
      (res) => {
        if (
          res.data &&
          res.data[FEATURES.IS_DYNAMIC_SHIFT_PLAN_ALERT_ENABLED]
        ) {
          this.dynamicShiftPlanEnabled = true;
          this.fetchDynamicShiftPlanDiff(true);
        }
      },
    );
  };

  fetchDynamicShiftPlanDiff = (isPlanEnabled) => {
    if (!!this.dynamicShiftPlanEnabled || !!isPlanEnabled) {
      this.fetchDynamicShiftPlans();
    }
  };

  fetchDynamicShiftPlans = () => {
    getDynamicShiftPlans().then((res) => {
      if (res.latestDynamicPlan && res.previousDynamicPlan) {
        if (
          arePlansSame(
            this.state.dynamicShiftPlanNotification.diff.plan1,
            res.latestDynamicPlan,
          )
        ) {
          return;
        } else if (isPlanActedUpon(res.latestDynamicPlan)) {
          this.setState({
            dynamicShiftPlanNotification: {
              ...this.state.dynamicShiftPlanNotification,
              diff: {
                planActedUpon: true,
              },
            },
          });
          return;
        }
        const parameterList = ["HEADCOUNT"];
        this.fetchDiff(
          res.latestDynamicPlan,
          res.previousDynamicPlan,
          parameterList,
        );
      }
    });
  };

  fetchDiff = (plan1, plan2, parameterList) => {
    getDynamicShiftPlanDiff(plan1, plan2, parameterList).then((res) => {
      if (res && res.dynamicShiftPlanDiff) {
        this.setState({
          dynamicShiftPlanNotification: {
            ...this.state.dynamicShiftPlanNotification,
            diff: res.dynamicShiftPlanDiff,
          },
        });
      }
    });
  };
}

export default Overviewv2;



// WEBPACK FOOTER //
// ./src/components/overview/Overviewv2.js